import { subDays, addDays } from '@valerahealth/ui-components/utils/date'

export const getDefaultRangeDates = () => {
  return [subDays(new Date(), 30), addDays(new Date(), 30)]
}
